
import WebLLCRESTApi from "../api/api";
import $ from 'jquery';

export default {
  name: "AddClientAccount",
  
  props: {
    clientId: String
  },
  
  data() {
    return {
      txtEmail: "",
      emailType: "gmail",
      txtImapHost: "",
      txtImapPort: "993",
      txtImapUsername: "",
      txtImapPassword: "",
      txtGmailUsername: "",
      txtGmailPassword: "",
      chkImapSSL: true,
      txtProxy: ""
    };
  },
  
  methods: {
    async onAddAccount() {
      var api = new WebLLCRESTApi("Client-Accounts");
      
      var loginData = (() => {
        if(this.emailType == "imap") {
          return {
            host: this.txtImapHost,
            port: parseInt(this.txtImapPort),
            username: this.txtImapUsername,
            password: this.txtImapPassword,
            ssl: this.chkImapSSL
          };
        }
        else if(this.emailType == "gmail") {
          return {
            host: "imap.gmail.com",
            port: 993,
            username: this.txtEmail,
            password: this.txtGmailPassword,
            ssl: true,
            boxes: ["[Gmail]/All Mail"]
          };
        }
      })();
      
      var newAcctObj = {
        email: this.txtEmail,
        type: this.emailType,
        login: JSON.stringify(loginData),
        proxy: this.txtProxy,
        clientId: this.clientId
      };
      
      var res = await api.addData(newAcctObj);
      var json = await res.json();
      
      this.$emit('added', json.id);
      $('#modal-add-client-account').modal('toggle');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/AddClientAccount.js